import React from "react";
import styled from "styled-components";
import foldIcon from "../../assets/images/btn_fold.png";

const StyledDiv = styled.div`
  &&& {
    border: 1px solid #d7cec4;
    margin: 0 0 20px;
    display: inline-table;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    p {
      background-color: #e4dcd3;
      padding: 12px;
      font-size: 14px;
      position: relative;
      font-weight: bold;
      text-align: left;
    }

    &.fold p::before {
      content: "";
      background: url(${foldIcon}) no-repeat;
      display: inline-block;
      width: 15px;
      height: 15px;
      position: absolute;
      left: 12px;
      cursor: pointer;
    }

    &.unfold p::before {
      content: "";
      background: url(${foldIcon}) no-repeat;
      display: inline-block;
      width: 15px;
      height: 15px;
      position: absolute;
      left: 12px;
      top: 50%;
      cursor: pointer;
      background-position: 0 -15px;
      transform: translateY(-53%);
    }

    &.fold p,
    &.unfold p {
      padding-left: 35px;
    }

    table {
      width: 98%;
      margin: 10px auto 0;
    }
  }
`;

const BoxAreaDiv = ({ title, children, className, onClick }) => {
  return (
    <StyledDiv className={className}>
      <p onClick={onClick}>{title}</p>
      {className !== "fold" && children}
    </StyledDiv>
  );
};

export default BoxAreaDiv;
